// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ClaimItemCorrectionResponseDTO
 */
export interface ClaimItemCorrectionResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    claimItemId: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    newAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    action: ClaimItemCorrectionResponseDTOActionEnum;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    currentItemAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    projectedItemAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    currentClaimAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    projectedClaimAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    hasFinalProposal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    orderUpdateWouldApply: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    orderUpdateSkippedReasons: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    relatedProposalCount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    relatedDocumentCount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    relatedEvidenceChaserItemCount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    relatedEvidenceChaserReviewCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimItemCorrectionResponseDTO
     */
    willDeactivateClaim: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ClaimItemCorrectionResponseDTOActionEnum {
    Deletion = 'deletion',
    Reduction = 'reduction'
}



